import gql from 'graphql-tag';

export const MY_MEMBERSHIPS = gql`
  query myMemberships($communityId: String) {
    myMemberships(filter: { communityId_eq: $communityId }) {
      _id
      unread
      user
      community
      communityId
      pagerank
    }
  }
`;

export const CLEAR_UNREAD = gql`
  mutation UpdateUnread($_id: String!) {
    updateUnread(_id: $_id, unread: 0)
  }
`;

// export const INC_UNREAD = gql`
//   subscription IncrementUread($communities: [ID!]!) {
//     updateUnread(communities: $communities) {
//       communityId
//       community
//     }
//   }
// `;
